export default {
    primary: {
        main: "#03a9f4",
        light: "#29b6f6",
        contrastText: "#fff"
    }
}